const getBaseURL = () => {
    // return `${process.env.REACT_APP_KTPL_API_HOST}/api`;
    return "https://role-scopes-and-db-optimize.kurumatravels.in/api";
}

const isProd = process.env.REACT_APP_ENV === "prod";
const isUAT = process.env.REACT_APP_ENV === "uat";

export {
    getBaseURL,
    isProd,
    isUAT
}